import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Reward: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={33}>Поощрение</Typography>
                    <Typography mb={1} ml={35}>Дата поощрения</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }}
                    />
                </Box>
            </Header>
            <Body>
                <Box display="flex" alignItems="center">
                    <Typography mr={6.5}>Дата поощрения</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mr: 1 }} 
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={11}>Поощрение</Typography>
                    <TextField
                        label="Дата приказа"
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={5}>Номер приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, ml: 2.8, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={5}>Параграф приказа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={1}>
                    <Typography mr={9.7}>Дата приказа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "170px", mb: 1, mr: 1}}
                    />
                </Box>
            </Body>
        </Box>
    );
};

export default Reward;

